var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.olympiads.length)?_c('div',{staticClass:"olympiad-preview"},_vm._l((_vm.olympiads),function(olympiad){return _c('olympiad-banner',{key:olympiad.id,attrs:{"olympiad":olympiad}})}),1):(_vm.isLoading)?_c('cs-loader'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }